import React from "react";
import Assets from "../modules/Assets/Assets";

export default function AssetsPage() {
  return <Assets />;
}
